export const MOBILE_APP_SDK_URL = 'https://js.appetize.io/embed.js';

export const MOBILE_APP_IFRAME_ID = 'project-usability-mobile-app-iframe';

export const MOBILE_APP_DEBUG_MAX_LOG_ENTRIES = 200;

export const MOBILE_APP_LOCATION_PRESETS: ReadonlyArray<{
  label: string;
  lat: number;
  lng: number;
}> = [
  { label: 'San Francisco', lat: 37.7749, lng: -122.4194 },
  { label: 'New York', lat: 40.7128, lng: -74.006 },
  { label: 'London', lat: 51.5074, lng: -0.1278 },
  { label: 'Bengaluru', lat: 12.9716, lng: 77.5946 },
];
